"use strict";

exports.__esModule = true;
exports.StyledGridItem = exports.StyledGridContainer = void 0;

var _stitches = require("../theme/stitches.config");

const StyledGridContainer = (0, _stitches.styled)('div', {});
exports.StyledGridContainer = StyledGridContainer;
const StyledGridItem = (0, _stitches.styled)('div', {
  margin: 0,
  boxSizing: 'border-box',
  padding: '$$gridGapUnit'
});
exports.StyledGridItem = StyledGridItem;